import React from 'react';
import image from "../assets/comming-soon.jpg"

const Blogs = () => {
    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
            <img src={image} alt="" srcset="" />
        </div>
    );
};

export default Blogs;